import { Map } from "immutable";

// The only place that knows how the show serializer nests the current
// estimate and label. If the backend names them differently, change these
// two constants — every consumer (duck, selectors, panels, rows) reads
// through the helpers below.
export const INBOUND_ESTIMATE_KEY = "estimate";
export const INBOUND_LABEL_KEY = "label";

export const INBOUND_STATUSES = ["draft", "estimated", "labeled"] as const;
export type InboundStatus = (typeof INBOUND_STATUSES)[number];

type MaybeShipment = Map<string, unknown> | null | undefined;

export const getInboundEstimate = (shipment: MaybeShipment) =>
  (shipment?.get(INBOUND_ESTIMATE_KEY) as Map<string, unknown>) || null;

export const getInboundLabel = (shipment: MaybeShipment) =>
  (shipment?.get(INBOUND_LABEL_KEY) as Map<string, unknown>) || null;

// Works for detail records (nested estimate/label) and bare list rows:
// nested objects win, a recognized `state` is the fallback (dead in practice —
// the backend never writes the column), anything else is a draft.
export const deriveInboundStatus = (shipment: MaybeShipment): InboundStatus => {
  if (!shipment) return "draft";
  if (getInboundLabel(shipment)) return "labeled";
  if (getInboundEstimate(shipment)) return "estimated";

  const state = shipment.get("state");
  return (INBOUND_STATUSES as readonly unknown[]).includes(state)
    ? (state as InboundStatus)
    : "draft";
};
